import { render, staticRenderFns } from "./VolunteerProfileView.vue?vue&type=template&id=40a1bd61"
import script from "./VolunteerProfileView.vue?vue&type=script&lang=ts"
export * from "./VolunteerProfileView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports